export default {
    expanded: 'bloko-tree-selector-item-expanded',
    item: 'bloko-tree-selector-item',
    items: 'bloko-tree-selector-items',
    text: 'bloko-tree-selector-item-text',
    input: 'bloko-tree-selector-input',
    toggle: 'bloko-tree-selector-toogle-node',
};
